export const environment = {
  production: true,
  api: 'https://apiweb.hotelctc.com.br',
  account_token: `RGg0VHU3RXQ5WXI0R2s0WWMzS2gzV3QyRnE2Q2s0SnYzWGk5RHkxUmc2SGY1SGE0SnI5Umg5WXI1VHc0SmEyQ3E1Rnk3R2MyWm42UWsxTHIxTHk4RXI0R2g5S2E3U2Y5RmgyWA==`
};
